import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CookieNames} from "../../../../shared/cookie/cookie-names";
import {SessionNames} from "../../../../shared/session/session-names";
import {PageDescription} from "../../../../shared/pages/page-description";
import {CrystalClearFrontUrl} from "../../../../shared/pages/crystal-clear-front-url";
import {CCRolesType} from "../../../../model/security/cc-roles-type";
import {Router} from "@angular/router";
import {ReportTask} from "../../../../model/archive/report-task";
import {CcStorageService} from "../../../../services/common/cc-storage.service";

@Component({
  selector: 'app-recap-sidebar',
  templateUrl: './recap-sidebar.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class RecapSidebarComponent implements OnInit {

  sidebarToggledChange: boolean = false;

  transPartKey: string = 'page.archive';

  menuItemsTop: MenuItem[] = [];
  menuItemsBottom: MenuItem[] = [];
  Origin = ReportTask.Origin;

  recapListDialogVisible: boolean = false;

  constructor(private router: Router,
              private storageService: CcStorageService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    //load from cookies
    if (this.storageService.check(CookieNames.MENU_SIDE_BAR_MAXIMIZED)) {
      if (this.storageService.get(CookieNames.MENU_SIDE_BAR_MAXIMIZED) === 'true') {
        this.sidebarToggledChange = true;
      }
    }
    const roles = JSON.parse(sessionStorage.getItem(SessionNames.USER_ROLES));
    if (roles) {
      const recapProfileMenu: MenuItem = this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_RECAP_PROFILE, roles, false);
      recapProfileMenu.label = 'page.profile.recap.title';
      recapProfileMenu.icon = 'fas fa-sliders';
      this.menuItemsTop = [
        // this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_RECAP_LIST, roles, false, [], () => {
        //   this.showRecapListDialog();
        // }),
        this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_RECAP_FORM, roles, false),
        recapProfileMenu,
        this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_RECAP_TASKS, roles, false)
      ];
    }
  }

// <span top
//   [class]="'bar-button'"
//     [pTooltip]="'recap.dialog_title'|translate"
//   (click)="showRecapListDialog()">
//     <i [class]="'bar-button-ico fa-solid fa-envelope-circle-check'"></i>
// <div class="bar-button-text">{{'recap.dialog_title'|translate}}</div>
// </span>
//   showRecapListDialog(): void {
//     this.recapListDialogVisible = true;
//   }

  SizeChanged($event) {
    this.storageService.set(CookieNames.MENU_SIDE_BAR_MAXIMIZED, $event);
  }

  private toMenuItem(pDesc: PageDescription, roles: CCRolesType.Roles[], iconOnly: boolean,
                     subItems: MenuItem[] = [], command?: (event?: any) => void): MenuItem {
    const menuItem = PageDescription.toMenuItem(pDesc, this.translateService,
      this.router, roles, iconOnly, subItems);
    if (command) {
      menuItem.command = command;
    }
    return menuItem;
  }
}
